@use "styles" as *;

.me-separator {
  display: block;
  background: $color-gray-200;

  &--horizontal {
    height: 1px;
    width: 100%;
  }

  &--vertical {
    width: 1px;
    height: 100%;
  }
}
